/** Small circular progress ring (Apple Watch "activity ring" style) — theme-aware via CSS vars. */
export default function ActivityRing({ pct, tone = 'ok', size = 56, stroke = 7 }: {
  pct: number; tone?: 'ok' | 'warn' | 'bad'; size?: number; stroke?: number;
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, pct));
  const offset = c - (clamped / 100) * c;
  const color = tone === 'bad' ? 'var(--bad)' : tone === 'warn' ? 'var(--warn)' : 'var(--ok)';
  return (
    <svg className="ringSvg" width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={`${clamped}%`}>
      <circle className="ringTrack" cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} />
      <circle
        className="ringVal" cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke}
        stroke={color} strokeDasharray={c} strokeDashoffset={offset}
      />
    </svg>
  );
}
